import Head from 'next/head'
import { useRouter } from 'next/router'
import ErrorPage from 'next/error'

import { CMS_TITLE_AUTO, CMS_DESC_AUTO, CMS_DESC_ODONTO, CMS_TITLE_ODONTO, CMS_TITLE_BIKE, CMS_DESC_BIKE, CMS_TITLE_RESIDENCIAL, CMS_DESC_RESIDENCIAL, CMS_TITLE_EMPRESARIAL, CMS_DESC_EMPRESARIAL, CMS_TITLE_VIDA, CMS_DESC_VIDA, CMS_TITLE, CMS_DESC } from '../../lib/constants'
import Container from '../../components/Container'
import Layout from '../../components/Layout'

import { getProductBySlug, getAllProducts } from '../../lib/api'

import markdownToHtml from '../../lib/markdownToHtml'
import ProductType from '../../dtos/product.types'
import HomeProducts from '../../components/HomeProducts'
import SecondHomeProducts from '../../components/SecondHomeProducts'

type Props = {
  product: ProductType
  moreProducts: ProductType[]
  preview?: boolean
}

const Products = ({ product, preview }: Props) => {
  const router = useRouter()

  if (!router.isFallback && !product?.id) {
    return <ErrorPage statusCode={404} />
  }
  const content =
    product.id == 'residencial'
      ? <>
        <title>{CMS_TITLE_RESIDENCIAL}</title>
        <meta name="description" content={CMS_DESC_RESIDENCIAL} />
        <meta property="og:title" key="title" content={CMS_TITLE_RESIDENCIAL} />
      </>
      : product.id == 'bike' ? <>
        <title>{CMS_TITLE_BIKE}</title>
        <meta name="description" content={CMS_DESC_BIKE} />
        <meta property="og:title" key="title" content={CMS_TITLE_BIKE} />
      </>
        : product.id == 'vida' ? <>
          <title>{CMS_TITLE_VIDA}</title>
          <meta name="description" content={CMS_DESC_VIDA} />
          <meta property="og:title" key="title" content={CMS_TITLE_VIDA} />
        </>
          : product.id == 'empresarial' ? <>
            <title>{CMS_TITLE_EMPRESARIAL}</title>
            <meta name="description" content={CMS_DESC_EMPRESARIAL} />
            <meta property="og:title" key="title" content={CMS_TITLE_EMPRESARIAL} />
          </>
            : product.id == 'odontologico' ? <>
              <title>{CMS_TITLE}</title>
              <meta name="description" content={CMS_DESC_ODONTO} />
              <meta property="og:title" key="title" content={CMS_TITLE_ODONTO} />
            </>
              : <>
                <title>{CMS_TITLE_AUTO}</title>
                <meta name="description" content={CMS_DESC_AUTO} />
                <meta property="og:title" key="title" content={CMS_TITLE_AUTO} />
              </>

  return (
    <Layout preview={preview}>
      <Head>
        {content}
      </Head>
      {router.isFallback ? (
        <div>Carregando...</div>
      ) : (
        <Container>
          <HomeProducts dataProd={product} />
          <SecondHomeProducts dataProd={product} />
        </Container>
      )}
    </Layout>
  )
}

export default Products

type Params = {
  params: {
    id: string
  }
}

export async function getStaticProps({ params }: Params) {
  const product = getProductBySlug(params.id, [
    'id',
    'titulo',
    'image',
    'compTitulo',
    'rota',
    'manual',
    'manualTwo',
    'frases',
    'valor',
    'button',
    'frasesMid',
    'coberturas',
    'questions',
    'content',
    'fraseCoberturas'
  ])
  const content = await markdownToHtml(product.content || '')

  return {
    props: {
      product: {
        ...product,
        content,
      },
    },
  }
}

export async function getStaticPaths() {
  const products = getAllProducts(['id'])

  return {
    paths: products.map((product) => {
      return {
        params: {
          id: product.id,
        },
      }
    }),
    fallback: false,
  }
}